<script>
    import modalService from '@/services/core/modal.service';
    import Modal from '@/components/modals/Modal';
    import utilsService from '@/services/core/utils.service';
    import httpService from '@/services/core/http.service';
    import ButtonSpinner from '@/components/shared/ButtonSpinner';
    import { DxSelectBox } from 'devextreme-vue/select-box';
    import DataSource from 'devextreme/data/data_source';

    export default {
        props: {
            modalData: Object
        },
        components: {
            Modal,
            ButtonSpinner,
            DxSelectBox
        },
        data() {
            return {
                isLoading: 0,
                entitiesLoaded: true,
                entitiesDs: {},
                companyId: 0,
                selectedEntity: null
            };
        },
        methods: {
            close() {
                modalService.closeModal();
            },
            save() {
                if (!this.selectedEntity.id) return;

                const url = `companies/${this.selectedEntity.id}/undo-deleted-battery`;

                this.isLoading++;
                httpService
                    .post(url)
                    .then(() => {
                        utilsService.showToast('Batttery saved');
                        this.modalData.onSuccess && this.modalData.onSuccess();
                        this.close();
                    })
                    .finally(() => this.isLoading--);
            },
            loadEntities() {
                this.selectedEntity = null;

                this.entitiesLoaded = false;

                const url = `companies/${this.companyId}/deleted-batteries`;

                httpService
                    .get(url)
                    .then(data => {
                        this.entitiesDs = new DataSource({
                            store: data,
                            paginate: true,
                            pageSize: 10
                        });
                    })
                    .finally(() => (this.entitiesLoaded = true));
            }
        },
        mounted() {
            this.companyId = this.modalData.item;
            this.loadEntities();
        }
    };
</script>

<template>
    <Modal>
        <form class="gsb-form" @submit.prevent="save">
            <div class="modal-content">
                <div class="modal-header">
                    <h3 class="modal-title">Undelete batteries</h3>
                </div>
                <div class="modal-body">
                    <div class="row mb-3">
                        <label class="col-sm-3 col-form-label">Battery</label>
                        <div class="col-sm">
                            <DxSelectBox
                                v-model="selectedEntity"
                                :data-source="entitiesDs"
                                display-expr="name"
                                :search-enabled="true"
                                search-mode="contains"
                                search-expr="name"
                                :search-timeout="200"
                                drop-down-button-template="loadIcon"
                            >
                                <template #loadIcon="{}">
                                    <div>
                                        <span v-show="!entitiesLoaded" class="spinner-border spinner-border-sm me-2" role="status"></span>
                                    </div>
                                </template>
                            </DxSelectBox>
                        </div>
                    </div>
                </div>

                <div class="modal-footer d-flex justify-content-between">
                    <button type="button" class="btn" @click="close">Close</button>
                    <ButtonSpinner :isLoading="isLoading" />
                </div>
            </div>
        </form>
    </Modal>
</template>

<style lang="scss" scoped>
    .dx-selectbox {
        height: 32px;
        line-height: 1.3;
        font-size: 13px;
    }
</style>
